import { ApiToken } from "../../types";


const tokens: ApiToken[] = [
	{
		id: 123,
		name: 'abcd',
		last_used_at: '2023',
		expires_at: '2023',
	}
]

export default tokens
